import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

export const AnimatedSection = ({ children, className = '', delay = 0, direction = 'up', once = true }) => {
  const { ref, inView } = useInView({ threshold: 0.08, triggerOnce: once });

  const variants = {
    hidden: {
      opacity: 0,
      y: direction === 'up' ? 32 : direction === 'down' ? -32 : 0,
      x: direction === 'left' ? 32 : direction === 'right' ? -32 : 0,
    },
    visible: {
      opacity: 1, y: 0, x: 0,
      transition: { duration: 0.6, delay, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={variants}
      className={className}
    >
      {children}
    </motion.div>
  );
};
